import Vue from 'vue'
import Router from 'vue-router'
import NotFound from './views/NotFound.vue'
import Preview from './views/Preview.vue'
import HomePage from './views/HomePage.vue'
import Projects from './views/Projects.vue'
import Project from './views/Project.vue'
import Blogpost from './views/Blogpost.vue'
import Blogposts from './views/Blogposts.vue'
import Page from './views/Page.vue'
import Meta from 'vue-meta'

Vue.use(Router)
Vue.use(Meta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true,

})

export default new Router({
  scrollBehavior () {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage,
    },
    {
      path: '/page/:uid',
      name: 'page',
      component: Page
    },
    {
      path: '/projects',
      name: 'projects',
      component: Projects
    },
    {
      path: '/projects/:uid',
      name: 'project',
      component: Project,
      meta: { transitionName: 'slide' }
    },
    {
      path: '/blogposts',
      name: 'blogposts',
      component: Blogposts
    },
    {
      path: '/blogposts/:uid',
      name: 'blogpost',
      component: Blogpost,
      meta: { transitionName: 'slide' }
    },
    {
      path: '/not-found',
      name: 'not-found',
      component: NotFound
    },
    {
      path: '/preview',
      name: 'preview',
      component: Preview
    },
    {
      path: '/prismic-website',
      redirect: '/page/prismic-website'
    },
    {
      path: '/magento2-webshop-laten-maken-2',
      redirect: '/page/magento2-webshop-laten-maken'
    },
    {
      path: '*',
      redirect: { name: 'not-found' }
    }
  ]
})
